module.exports = __webpack_public_path__ + "static/img/meilizhihui_icon.31bd728.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img_icon/meilizhihui_icon.png
// module id = Kli2
// module chunks = 1